export default __webpack_public_path__ + "static/company-incorporation-5710dc411658f1de5ccff081fa8fddf2.png";